const Kirby = {
  level1: '#FDE5ED',
  Ki100: '#FDE5ED',
  level2: '#FBBED2',
  Ki200: '#FBBED2',
  level3: '#F995B4',
  Ki300: '#F995B4',
  level4: '#F44C7E',
  Ki400: '#F44C7E',
  level5: '#E12F65',
  Ki500: '#E12F65',
  level6: '#B5265C',
  Ki600: '#B5265C',
};

export { Kirby };
